import * as React from 'react';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OTPInput from './OtpInput';
import { useState } from 'react';
import {  ReSendOtp, Verify } from 'API/Authentication/api';
import { Box, Button, Typography } from '@mui/material';
import LoadingButton from "@mui/lab/LoadingButton";
import {  Stack } from '@mui/system';
import { useEffect } from 'react';
import { MdClose } from "react-icons/md";


export default function OtpModal(props) {
  const [otp,setOtp]=useState('')
  const [IsLoading,setIsLoading] = useState(false)

  const [count,setCount]=useState(120)

  useEffect(()=>{
    if(!props.open){

      setOtp('')
    }
  },[props.handleClose])

  useEffect(()=>{
    if(props.open){
      setTimeout(()=>{
        if(count>0){
          setCount(count-1)
        }
      },1000)
    }

  },[count,props.open])

  useEffect(()=>{
    if(!props.open){
      setCount(120)
    }
  },[props.handleClose])

  const handleVerifyOtp=()=>{
    if(otp&&otp.length===6){
      Verify({username:props.phone,otp:otp},props.handleAlertOpen,props.setAlertMessage,props.setAlertType,setIsLoading,setOtp)
    }
    else{
      props.setAlertMessage("Please enter the valid otp")
      props.setAlertType("error")
      props.handleAlertOpen()
    }

  }

  const handleResendOtp=()=>{
    if(count===0){
      ReSendOtp({username:props.phone,password:props.password},props.handleOpen,props.handleAlertOpen,props.setAlertMessage,props.setAlertType,props.setIsLoading,setCount)

    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{position:'absolute',top:8,right:8,cursor:'pointer'}}>
          <MdClose style={{fontSize:'25px'}} onClick={()=>props.handleClose()}/>
        </Box>

        <DialogTitle id="alert-dialog-title" variant='h4' sx={{mt:0.2,mr:2}}>
          {"We have sent you an OTP to your mobile number "}
        </DialogTitle>
        <Typography variant='h4' textAlign={"center"}>Please enter OTP</Typography>
        <DialogContent sx={{margin:'0px',pt:0}}>
            <OTPInput setOtp={setOtp} otp={otp}/>
            <Stack>
              <Typography variant='caption' display={count===0?'none':'block'} fontSize='16px' textAlign={"center"}>
                  Resend OTP in {count} seconds
              </Typography>
              <Button variant='text' sx={{display:count===0?'flex':'none'}} onClick={()=>handleResendOtp()}>Resend OTP</Button>
            </Stack>
        </DialogContent>
        <DialogActions sx={{justifyContent:'center'}}>
          {/* <Button onClick={props.handleClose}>Disagree</Button> */}
          <LoadingButton variant='contained'  loading={IsLoading} color='secondary' size='small' onClick={handleVerifyOtp}>
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
